document.addEventListener('DOMContentLoaded',function(){
  if(!location.pathname.includes('bedruckte-armbander-fertig-konfektioniert'))return;
  var variant=document.querySelector('[data-variant-select]');
  var ribbon=document.querySelector('.preview-ribbon');
  if(!variant||!ribbon)return;
  var step=variant.closest('.step');
  var wrapper=document.createElement('div');
  wrapper.className='armband-options';

  var printLabel=document.createElement('label');
  printLabel.append(document.createTextNode('Textdruck auf dem Armband'));
  var printSelect=document.createElement('select');
  printSelect.name='properties[Textdruck]';
  var once=document.createElement('option');
  once.value='Einmal mittig';
  once.textContent='Einmal mittig';
  var multiple=document.createElement('option');
  multiple.value='Mehrfach aufgedruckt';
  multiple.textContent='Mehrfach aufgedruckt';
  printSelect.append(once,multiple);
  printLabel.appendChild(printSelect);

  var closureLabel=document.createElement('label');
  closureLabel.append(document.createTextNode('Farbe des Armbandverschlusses'));
  var closureSelect=document.createElement('select');
  closureSelect.name='properties[Farbe Armbandverschluss]';
  var white=document.createElement('option');
  white.value='Weiß';
  white.textContent='Weiß';
  var black=document.createElement('option');
  black.value='Schwarz';
  black.textContent='Schwarz';
  closureSelect.append(white,black);
  closureLabel.appendChild(closureSelect);

  wrapper.append(printLabel,closureLabel);
  var note=step.querySelector('.armband-note');
  if(note)step.insertBefore(wrapper,note);
  else step.appendChild(wrapper);

  function clearRepeats(){
    ribbon.querySelectorAll('[data-armband-repeat]').forEach(function(node){node.remove()});
  }
  function updatePreview(){
    clearRepeats();
    if(printSelect.value==='Mehrfach aufgedruckt'){
      var originals=Array.from(ribbon.children);
      originals.forEach(function(node,index){
        var clone=node.cloneNode(true);
        clone.dataset.armbandRepeat='true';
        if(index===0)clone.classList.add('armband-repeat-start');
        ribbon.appendChild(clone);
      });
    }
    requestAnimationFrame(function(){window.dispatchEvent(new Event('resize'))});
  }
  printSelect.addEventListener('change',updatePreview);
  window.addEventListener('band:logos-rendered',updatePreview);
  updatePreview();
});
